var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCoverageIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9399 4.5H4.8999V19.5H19.8999V4.5H18.9399ZM5.8999 5.5H9.4599L5.8999 9.06V5.5ZM5.8999 10.47L10.8699 5.5H13.6999L5.8999 13.3V10.47ZM5.8999 14.715L15.1149 5.5H17.9399L5.8999 17.54V14.715ZM18.8999 18.5H14.8399L18.8999 14.44V18.5ZM18.8999 13.03L13.4299 18.5H10.5999L18.8999 10.2V13.03ZM18.8999 8.785L9.1849 18.5H6.3599L18.8999 5.96V8.785Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCoverageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Coverage_icon.bf846d838e11f625c07fd57f6f1f09f4.svg";